import enTranslation from "assets/locales/en.json";
import viTranslation from "assets/locales/vi.json";
import khTranslation from "assets/locales/kh.json";
import laTranslation from "assets/locales/la.json";
import mmTranslation from "assets/locales/mm.json";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18next
	.use(initReactI18next)
	.use(LanguageDetector)
	.init({
		resources: {
			en: {
				translation: enTranslation,
			},
			vi: {
				translation: viTranslation,
			},
			la: {
				translation: laTranslation,
			},
			mm: {
				translation: mmTranslation,
			},
			kh: {
				translation: khTranslation,
			},
		},
		fallbackLng: "en",
		detection: {
			order: ["cookie", "localStorage", "queryString", "path", "htmlTag"],
			caches: ["cookie", "localStorage"],
		},
		react: {
			useSuspense: false,
		},
		interpolation: {
			escapeValue: false,
		},
	});

export default i18next;
